import { HTTPClient } from "@abaco/web-common/src/HTTP";
import { ActivitiesFilter, Costs } from "../models/TotalCostsModels";
import { Plot } from "@abaco/portal-global-state/src/modules/global-state/models/Plot";
import { Block } from "@abaco/crop-plan-module/src/modules/crop-plan-module/models/Block";
import { VarietyBase } from "../models/Variety";
import { ConsumptionsCostsByActivityAllCampaign, ConsumptionsCostsByActivityData, ConsumptionsCostsData } from "../models/ConsumptionsCosts";
import axios, { CancelTokenSource } from "axios";
import { Planting } from "../models/Index";
import { PagingParams, PagedResults } from "@abaco/web-common/src/Paging";

export default class CostConsumptionApi {

    private http: HTTPClient;
    private cancelTokenSource: CancelTokenSource | null;

    constructor(http: HTTPClient) {
        this.http = http;
        this.cancelTokenSource = null;
    }

    public async getAllActivities(): Promise<ActivitiesFilter[]>
    {
        const res = await this.http.get('/sitiagri-rest-api/api_basic/v1/ref_prices/dashboard/activity_families')

        return res.data
    }

    public async getTotalCosts(
        pk_cuaa: number,
        campaign: number,
        plot: Plot | null,
        block: Block | null,
        variety: VarietyBase | null,
        activity: ActivitiesFilter
    ): Promise<Costs>
    {
        const params: {
            group_id?: number;
            plot_id?: number;
            block_id?: number;
            variety_id?: number;
        } = {}

        if(activity.group_id !== 0)
            params.group_id = activity.group_id

        if(plot)
            params.plot_id = plot.plot_id

        if(block)
            params.block_id = block.block_id

        if(variety && variety.id)
            params.variety_id = variety.id

        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/ref_prices/dashboard/subjects/${pk_cuaa}/${campaign}/total_costs`, {
            params
        })

        return res.data
    }

    public async getCCByPlotAllCampaigns(pkCuaa: number, campaign: number, plotId: number | null, groupId: number | null, blockId: number | null, varietyId: number | null): Promise<ConsumptionsCostsData[]> {
        // if (this.cancelTokenSource) {
        //     this.cancelTokenSource.cancel();
        // }
        // this.cancelTokenSource = axios.CancelToken.source();
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/ref_prices/dashboard/subjects/${pkCuaa}/${campaign}/consumptions_by_year`, {
            params: {
                plot_id: plotId ? plotId : undefined,
                block_id: blockId ? blockId : undefined,
                group_id: groupId ? groupId : undefined,
                variety_id: varietyId ? varietyId : undefined,
                offset: 0,
                count: 300,
            }
        });
        return res.data;
    }
    public async getCCByActivityAllCampaigns(pkCuaa: number, campaign: number, plotId: number | null, blockId: number | null, varietyId: number | null): Promise<ConsumptionsCostsByActivityAllCampaign[]> {
        // if (this.cancelTokenSource) {
        //     this.cancelTokenSource.cancel();
        // }
        // this.cancelTokenSource = axios.CancelToken.source();
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/ref_prices/dashboard/subjects/${pkCuaa}/${campaign}/costs_by_year`, {
            params: {
                plot_id: plotId ? plotId : undefined,
                block_id: blockId ? blockId : undefined,
                variety_id: varietyId ? varietyId : undefined,
                offset: 0,
                count: 300,
            }
        });
        return res.data;
    }

    public async getConsumptionsCostsByBlock(pkCuaa: number, campaign: number): Promise<ConsumptionsCostsData> {
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/ref_prices/dashboard/subjects/${pkCuaa}/${campaign}/consumptions_detail`, {
            params: {
                offset: 0,
                count: 300,
            }
        });
        return res.data;
    }

    public async getConsumptionsCostsByActivity(pkCuaa: number, campaign: number): Promise<ConsumptionsCostsByActivityData> {
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/ref_prices/dashboard/subjects/${pkCuaa}/${campaign}/total_costs`, {
            params: {
                offset: 0,
                count: 300,
            }
        });
        return res.data;
    }

    public async getCampaigns(pkCuaa: number): Promise<number[]> {
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/plots/subjects/${pkCuaa}/dictionary_campaigns`, {
            params: {
                offset: 0,
                count: 300,
            }
        });
        return res.data && res.data.records.length > 0 ? res.data.records.map((r: any) => r.campaign) : [];
    }

    public async getBlocksOld(pkCuaa: number, campaign: number, paging: PagingParams): Promise<PagedResults<Planting>> {
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/dashboard/subjects/${pkCuaa}/plantings?include_graphic=true`, {
            params: {
                filter: `campaign eq ${campaign}`,
                offset: paging.offset,
                count: paging.count,
            }
        });
        return res.data;
    }

    public async getAllBlocks(pkCuaa: number, campaign: number): Promise<Planting[]> {
        let count = 0;
        let res: Planting[] = [];
        let totalcount = 0;
        do {
            const curPage = await this.getBlocksOld(pkCuaa, campaign, { offset: count, count: 300 });
            count += curPage.count;
            totalcount = curPage.totalcount;
            res = [...res, ...curPage.records];
        } while (count < totalcount)

        // FOR TESTING
        // res.find(e=> e.block_id === 287837) ? res.find(e=> e.block_id === 287837)!.geometry = {
        //     "srs": "EPSG:3857",
        //     "wkt_geometry": "POLYGON ((1605100.95999896 4985928.21015462, 1605101.83922134 4986024.45246394, 1604725.09936212 4986017.03336698, 1604731.86952008 4985878.72058896, 1605100.95999896 4985928.21015462))"
        // } : '';
        // res.find(e=> e.block_id === 287835) ? res.find(e=> e.block_id === 287835)!.geometry = {
        //     "srs": "EPSG:3857",
        //     "wkt_geometry": "POLYGON ((1605100.05015641 4985827.7012623, 1605100.95999948 4985928.21007731, 1604731.8695206 4985878.72051166, 1604739.5766588 4985747.95383664, 1605100.05015641 4985827.7012623))"
        // } : '';
        // res.find(e=> e.block_id === 287838) ? res.find(e=> e.block_id === 287838)!.geometry = {
        //     "srs": "EPSG:3857",
        //     "wkt_geometry": "POLYGON ((1605139.70546544 4986272.70497848, 1605152.53102352 4985976.04367033, 1605186.73679344 4985976.1886704, 1605181.69535624 4986274.75327441, 1605139.70546544 4986272.70497848))"
        // } : '';
        // res.find(e=> e.block_id === 287839) ? res.find(e=> e.block_id === 287839)!.geometry = {
        //     "srs": "EPSG:3857",
        //     "wkt_geometry": "POLYGON ((1605190.91266841 4985728.88449857, 1605186.73679293 4985976.18874772, 1605186.72999948 4985976.19007732, 1605152.70141959 4985972.10232749, 1605163.26073192 4985727.86037013, 1605190.91266841 4985728.88449857))"
        // } : '';
        // res.find(e=> e.block_id === 287836) ? res.find(e=> e.block_id === 287836)!.geometry = {
        //     "srs": "EPSG:3857",
        //     "wkt_geometry": "POLYGON ((1604935.98229521 4985696.1181047, 1605109.37174702 4985725.34104603, 1605089.50012315 4985792.74859798, 1604923.51382241 4985754.17435408, 1604935.98229521 4985696.1181047))"
        // } : '';
        return res;
    }

}
